import { render } from "./기본-상세페이지.vue?vue&type=template&id=5b9c6b41"
import script from "./기본-상세페이지.vue?vue&type=script&lang=js"
export * from "./기본-상세페이지.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__